/// <reference path="../../lib/tsd.d.ts" />

import {Options, ReceiverInterface} from "./receiver";
import {Collection} from "../lib/event-interface";
import {JoinedRoomModeSpecific} from "../chatserver/sx-server";
import logging from "../utils/log";
import vxServer from "../chatserver/vx-server";
import {Player, PlayerHandler, H5LivePlayerFactory, HlsJsPlayerFactory, HlsPlayerFactory, WebRTCPlayerFactory, JpegPlayerFactory} from "vchat-player";

export class VisitXReceiver implements ReceiverInterface
{
	getCurrentName(): string
	{
		return "VisitXReceiver";
	}

	setFlag(s: string, enabled : boolean = false): void
	{
		this.$container[enabled ? "addClass" : "removeClass"](s);
	}

	muteForced: boolean;
	private vxPlayer: any = null;

	private TAG = "[Sxc.Chat.VisitxReceiver]";

	private $container : JQuery;

	private initialized = false;
	private ready       = false;

	private currentServer : string;
	private currentStream : string;
	private lastServer : string;
	private lastStream : string;

	private volume : number = null;

	public evt : Collection;

	constructor (private params : Options)
	{
		this.evt = new Collection("vx-receiver");
	}

	static isSupported()
	{
		return true;
	}

	public connect()
	{
		// Nothing
	}

	isReady()
	{
		return this.ready;
	}

	isInitialized()
	{
		return this.initialized;
	}

	initialize($container, standalone = true)
	{
		if (this.initialized) return;
		this.initialized = true;

		this.$container = $container;

		if (standalone)
		{
			this.$container.on("mouseenter", (e) => {
				this.evt.trigger("mouseenter");
			});

			this.$container.on("mouseleave", (e) => {
				this.evt.trigger("mouseleave");
			});
		}

		this._onReady(null);
	}

	/**
	 * This method called when the flash object is ready.
	 */
	public _onReady(...args)
	{
		logging.log(this.TAG, "[_onReady]", args);

		this.ready = true;
		this.evt.trigger("ready");
	}

	/**
	 * Triggered by flash when the playback starts after a play call
	 * @param args
	 * @private
	 */
	public _onPlaying(...args)
	{
		logging.log(this.TAG, "[_onPlaying]", args);

		this.setVolume(this.volume);

		this.$container.css("opacity", 1);

		this.evt.trigger("playing");
	}

	/**
	 * Triggered by flash when the stream's dimension is changed
	 */
	public _onVideoDimension(w, h)
	{
		logging.log(this.TAG, "[_onVideoDimension]", w, h);
		this.evt.trigger("videoDimension", w, h);
	}

	public _onPlayFailed(...args)
	{
		logging.log(this.TAG, "_onPlayFailed", args);
		this.evt.trigger("playFailed");
	}

	destroy()
	{
		this.$container.empty();

		this.ready = false;

		if(this.vxPlayer == null) { return; }

		this.vxPlayer.destroy();
	}

	play(stream : string) : void
	{
		const onReady = () =>
		{
			if (this.vxPlayer !== null) {
				this.vxPlayer.destroy();
			}

			this.currentStream = stream;

			let playerConfig = {
				container: document.getElementById('vx'),
				handler: new vxPlayerHandler(),
				factories: [new H5LivePlayerFactory(), new HlsJsPlayerFactory(), new HlsPlayerFactory(), new WebRTCPlayerFactory(), new JpegPlayerFactory()]
			};
			this.vxPlayer = new Player(playerConfig);
			this.vxPlayer.play(vxServer.getVXSourceSet()).then(() => { this._onPlaying(); });
		};

		if (!this.ready) {
			logging.log(this.TAG, "[play.queue.beforeready]", stream);
			this.evt.one("ready", onReady);
		} else {
			onReady();
		}
	}

	disconnect()
	{
		logging.log(this.TAG, "[disconnect]");

		this.stop();
	}

	setVolume(volume : number):void
	{
		this.volume = volume;

		if (!this.isReady() || this.vxPlayer == null) return;

		this.vxPlayer.volume = volume / 100;
	}

	stop():void
	{
		if (!this.isReady() || this.vxPlayer == null) return;

		this.vxPlayer.stop();

		this.currentStream = null;
	}

	restoreLastStream() : void {
		this.play(this.lastServer);
	}


	forceMute(forced : boolean) : void
	{
		this.muteForced = forced;

		if(this.vxPlayer == null) { return; }

		this.vxPlayer.volume = this.volume;
	}

	clear()
	{
		this.$container.css("opacity", 0);
	}

	reStreamIfChanged(stream : string)
	{
		if (this.currentStream && this.currentStream !== stream) {
			this.stop();
			this.play(stream);
		}
	}

	public getVideoObject() {
		return this.vxPlayer;
	}
}

class vxPlayerHandler {
	onCameraDenied(): void {}

	onCameraOff(): void {}
	onCameraOn(): void {}

	onError(error: string | object): void {}

	onPlayError(level: number, error?: any): void {}

	onPlayInfo(info): void {}

	onPlayStart(stream: string): void {}
	onPlayStop(): void {}

	onPlayerSwitch(format: string): void {}

	onPlayerSwitchComplete(format: any): void {}

	onPublishStart(): void {}
	onPublishStop(): void {}

	onSendMetrics(info: any): void {}
}
